import { create } from 'zustand';

const popUpAsset = {
    isOpen: false,
    selectedTimeUploadType: '',
    selectedTimeUploadValue: null,
    // selectedBrand: [],
    selectedFormatUploadType: null,
    isTermsChecked: false,
    isUploading: false,
    isBlockNotification: true,
};

export const usePopUpStore = create((set, get) => ({
    ...popUpAsset,
    onChangePopUpStore: (newState) => set((state) => ({ ...state, ...newState })),
    onResetPopUpStore: () => set(() => ({ ...popUpAsset, error: {} })),

    validateFormPopUpStore: () => {
        const { selectedTimeUploadType, selectedTimeUploadValue, selectedFormatUploadType, isTermsChecked } = get();

        const error = {};

        if (!selectedTimeUploadType) {
            error.selectedTimeUploadType = 'Tipe sell out tidak boleh kosong';
        }

        if (!selectedTimeUploadValue) {
            error.selectedTimeUploadValue = 'Tanggal sell out tidak boleh kosong';
        }

        if (!selectedFormatUploadType) {
            error.selectedFormatUploadType = 'Tipe upload tidak boleh kosong';
        }

        if (!isTermsChecked) {
            error.isTermsChecked = 'Anda harus menyetujui syarat dan ketentuan';
        }

        set((state) => ({
            ...state,
            error,
        }));

        return Object.keys(error).length === 0;
    },
}));

const assetState = {
    brandOptions: [],
    timeUploadOptions: [],
    uploadTypeOptions: [],
    blockedUpload: {},
    isLoadingAsset: true,
    progress: 0,
    controller: null,
};

export const usePopUpAssetStore = create((set) => ({
    ...assetState,
    onChangePopupAssetStore: (newState) => set((state) => ({ ...state, ...newState })),
    onResetPopUpAssetStore: () => set(() => ({ ...assetState, controller: null })),
}));
